import React, { useState, type ReactNode } from 'react';
import CustomCheckBox from './customCheckBox';
import { type RadioButtonProps } from './customRadio';

type CustomControlCheckbox = RadioButtonProps & {
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  linkLabel: string | ReactNode;
  file?: boolean;
};

const CustomControlCheckBox = (props: CustomControlCheckbox): JSX.Element => {
  const { label: Label } = props;
  const [selected, setSelected] = useState<boolean>(false);
  return (
    <CustomCheckBox
      {...props}
      onChange={(e: React.SyntheticEvent) => {
        if (
          (props.disabled !== undefined && props.disabled !== null && !props.disabled) ||
          (selected !== undefined && selected !== null && !selected)
        ) {
          props?.onChange(e);
        }
      }}
      checked={props.value}
      disabled={(props.disabled ?? false) || ((props.file ?? false) && !selected)}
      label={
        <span className='flex'>
          {Label}
          <span
            onClick={(e) => {
              setSelected(true);
            }}>
            {props.linkLabel}
          </span>
        </span>
      }
    />
  );
};

export default CustomControlCheckBox;
